import inFlightCancellationFacade from "./inFlightCancellationFacade";

const groupedInFlightCancellationFacade = () => {
  const groups = {};

  return {
    cancelTokenExecutorFactory: group => cancel => {
      const {
        [group]: {
          cancellationFacade: { cancelTokenExecutor }
        }
      } = groups;

      return cancelTokenExecutor(cancel);
    },
    makeRequestFactory:
      group =>
      async ({ cancelInFlight, request }) => {
        if (!groups[group]) {
          groups[group] = {
            cancellationFacade: inFlightCancellationFacade(),
            count: 0
          };
        }
        const {
          cancellationFacade: { makeRequest }
        } = groups[group];
        try {
          groups[group].count++;

          return await makeRequest({ cancelInFlight, request });
        } finally {
          if (!--groups[group].count) {
            delete groups[group];
          }
        }
      }
  };
};

export default groupedInFlightCancellationFacade;
